import React from 'react';
import { Label } from '../../../../UiKit';

export const ValetTagLabel = React.memo(
  ({ title = '', bgColor = '', color = '', image = '' }) => {
    if (image) {
      return (
        <div className='iconMarginR'>
          <img src={image} height='20px' width={'100%'} />
        </div>
      );
    }

    return (
      <div
        className={
          'tw-h-full tw-flex tw-items-center tw-justify-center tw-text-100 tw-font-semibold  tw-px-2 tw-py-1  tw-rounded-md tw-leading-tight'
        }
        style={{ backgroundColor: bgColor, color: color }}
      >
        {title}
      </div>
    );
  },
);
